// extracted by css-extract-rspack-plugin
export default {"widgetSeparator":"widget-separator--BIVRN_4uwxEp_dEN"};